import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PopupWrapper from '../../../../components/popup/PopupWrapper';
import { getButtonClass } from '../../../../components/popup/popupUtils';

/**
 * 썸네일 팝업 컴포넌트
 * 이미지 업로드 + 입력 필드
 */
const ThumbnailPopup = ({ config, onClose }) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [validated, setValidated] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (config?.initialData) {
      setTitle(config.initialData.title || '');
      setDescription(config.initialData.description || '');
      setImage(config.initialData.image || null);
    }
    setValidated(false);
  }, [config?.initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (!form.checkValidity()) {
      setValidated(true);
      return;
    }
    onClose(true, { image, title, description });
  };

  const handleLeftButtonClick = () => {
    onClose(false);
  };

  const handleRightButtonClick = () => {
    const form = formRef.current;
    if (form) {
      form.requestSubmit();
    }
  };

  return (
    <PopupWrapper
      config={config}
      onClose={onClose}
      displayType={config?.displayType || 'modal'}
      className="popup-uploader"
    >
      <div className="main-popup-body">
        <div className="main-popup-uploader">
          <div className="row" style={{ marginBottom: '20px' }}>
            <div className="col-md-8 col-12">
              <label>
                {t('popup.thumbnailPopup.coverImage')}<span style={{ color: 'red' }}>*</span>
              </label>
              <div>
                <div id="popup-thumbnail-uploader" style={{ display: 'none' }} className="mt-1"></div>
                <div id="popup-thumbnail-img-show" style={{ display: 'block' }} className="mt-1">
                  <img
                    src={image?.url || '/assets/images/page/register/profile_empty.png'}
                    alt="thumbnail"
                    id="popup-thumbnail-img"
                    data-id={image?.fileId || ''}
                    style={{ width: '200px' }}
                  />
                </div>
                <div className="info_text">
                  <p style={{ fontSize: '12px !important', marginBottom: '3px !important' }}>
                    {t('popup.thumbnailPopup.imageFormat')}
                  </p>
                  <p
                    style={{ fontSize: '12px !important', color: 'red', marginBottom: '3px !important' }}
                    id="popup-uploader-image-alert-span"
                  ></p>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'left', gap: '20px' }}>
                <button
                  type="button"
                  className="btn btn-dark"
                  style={{
                    height: '35px',
                    width: '100px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  id="popup-modal-image-upload-btn"
                >
                  {t('popup.thumbnailPopup.uploadFile')}
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  style={{
                    height: '35px',
                    width: '100px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  id="popup-modal-image-delete-btn"
                >
                  {t('popup.thumbnailPopup.deleteFile')}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="main-popup-form">
          <form
            ref={formRef}
            className={`needs-validation ${validated ? 'was-validated' : ''}`}
            noValidate
            onSubmit={handleSubmit}
          >
            <div className="row">
              <div className="single-input-item">
                <label htmlFor="popup-thumbnail-input" className="required">
                  {t('popup.thumbnailPopup.workTitle')}<span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  id="popup-thumbnail-input"
                  required
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <div className="invalid-feedback">{t('popup.thumbnailPopup.requiredInfo')}</div>
              </div>
              <div className="main-popup-textarea">
                <div className="single-input-item">
                  <label htmlFor="popup-thumbnail-textarea">
                    {t('popup.thumbnailPopup.workDescription')}<span style={{ color: 'red' }}>*</span>
                  </label>
                  <textarea
                    id="popup-thumbnail-textarea"
                    className="form-control"
                    required
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ marginBottom: '0px !important' }}
                  />
                  <div className="invalid-feedback">{t('popup.thumbnailPopup.requiredField')}</div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="main-popup-footer d-flex justify-content-between">
        {config?.leftButton && (
          <button
            type="button"
            className={`btn main-popup-left-btn ${getButtonClass(config.leftButton.color || 'btn-secondary')}`}
            onClick={handleLeftButtonClick}
          >
            {config.leftButton.text || t('popup.common.cancel')}
          </button>
        )}
        {config?.rightButton && (
          <button
            type="button"
            className={`btn main-popup-right-btn ${getButtonClass(config.rightButton.color || 'btn-primary')}`}
            onClick={handleRightButtonClick}
          >
            {config.rightButton.text || t('popup.common.save')}
          </button>
        )}
      </div>
    </PopupWrapper>
  );
};

export default ThumbnailPopup;

